import axios from 'axios';
import {
  isSessionExpiredDetail,
  redirectToLoginForSessionExpiration,
} from './utils/sessionExpired';
import { getAnalyticsVisitorId } from './utils/analyticsVisitor';
import { notifyRateLimited } from './utils/rateLimitEvents';

axios.defaults.withCredentials = true;

const getCookie = (name: string): string | null => {
  const escapedName = name.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
  const match = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

axios.interceptors.request.use((config) => {
  config.withCredentials = true;
  const method = config.method?.toUpperCase() ?? 'GET';
  const isUnsafe = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method);
  const csrfToken = getCookie('csrf_token');
  if (isUnsafe && csrfToken) {
    config.headers = config.headers ?? {};
    config.headers['X-CSRF-Token'] = csrfToken;
  }
  const visitorId = getAnalyticsVisitorId();
  if (visitorId) {
    config.headers = config.headers ?? {};
    config.headers['X-Analytics-Visitor-Id'] = visitorId;
  }

  const authorization = config.headers?.Authorization;
  if (
    typeof authorization === 'string' &&
    /Bearer\s+(null|undefined)?$/i.test(authorization.trim())
  ) {
    delete config.headers.Authorization;
  }

  return config;
});

// グローバルなレスポンスインターセプターを設定
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 429) {
      notifyRateLimited({
        source: 'axios',
        retryAfter: error.response?.headers?.['retry-after'] ?? null,
      });
    }
    if (
      status === 401 &&
      isSessionExpiredDetail(error.response?.data?.detail)
    ) {
      delete axios.defaults.headers.common['Authorization'];
      redirectToLoginForSessionExpiration();
    }
    return Promise.reject(error);
  }
);

export default axios;
